// lib/mock/users.ts
import type { User } from "@/types";

export const MOCK_USERS: User[] = [
  {
    id: 1,
    name: "علی محمدی",
    email: "ali@example.com",
    phone: "09121234567",
    role: "admin",
    isActive: true,
    ordersCount: 12,
    totalSpent: 15665300,
    createdAt: Date.now() - 120 * 86400000,
  },
  {
    id: 2,
    name: "سارا احمدی",
    email: "sara@example.com",
    phone: "09129876543",
    role: "customer",
    isActive: true,
    ordersCount: 5,
    totalSpent: 5371500,
    createdAt: Date.now() - 90 * 86400000,
  },
  {
    id: 3,
    name: "رضا کریمی",
    email: "reza@example.com",
    phone: "09135551234",
    role: "manager",
    isActive: true,
    ordersCount: 8,
    totalSpent: 7147100,
    createdAt: Date.now() - 60 * 86400000,
  },
  {
    id: 4,
    name: "مریم صادقی",
    email: "maryam@example.com",
    phone: "09147778899",
    role: "customer",
    isActive: false,
    ordersCount: 2,
    totalSpent: 5251500,
    createdAt: Date.now() - 45 * 86400000,
  },
  {
    id: 5,
    name: "حسین بیات",
    email: "hossein@example.com",
    phone: "09112345678",
    role: "customer",
    isActive: true,
    ordersCount: 1,
    totalSpent: 1716000,
    createdAt: Date.now() - 30 * 86400000,
  },
  {
    id: 6,
    name: "نیلوفر رضایی",
    email: "niloofar@example.com",
    phone: "09128887766",
    role: "customer",
    isActive: true,
    ordersCount: 15,
    totalSpent: 23400000,
    createdAt: Date.now() - 20 * 86400000,
  },
  {
    id: 7,
    name: "امیر حسینی",
    email: "amir@example.com",
    phone: "09136664422",
    role: "customer",
    isActive: true,
    ordersCount: 3,
    totalSpent: 8905000,
    createdAt: Date.now() - 10 * 86400000,
  },
  {
    id: 8,
    name: "فاطمه نوری",
    email: "fateme@example.com",
    phone: "09144443322",
    role: "customer",
    isActive: false,
    ordersCount: 0,
    totalSpent: 0,
    createdAt: Date.now() - 5 * 86400000,
  },
];